import React from "react"
import { Skeleton as ShadcnSkeleton } from "../../../ui/skeleton"
import { cn } from "../../../lib/utils"

/**
 * Skelton component - Migrated to use shadcn/ui Skeleton
 * Used for table loading states
 * 
 * @param {number} hLen - Number of header columns (default: 6)
 * @param {number} vLen - Number of body rows (default: 6)
 * @param {string} width - Container width (default: "100%")
 */
const Skeleton = (props) => {
  const { hLen = 6, vLen = 6, width = "100%" } = props

  return (
    <div className="rounded-lg border bg-card shadow-sm" style={{ width }}>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr>
              {[...Array(hLen)].map((_, i) => (
                <th key={i} className="p-2">
                  <ShadcnSkeleton className="h-[30px] w-full" />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {[...Array(vLen)].map((_, i) => (
              <tr key={i}>
                {[...Array(hLen)].map((_, j) => (
                  <td key={j} className="p-2 text-center">
                    <ShadcnSkeleton className="h-[25px] w-[150px] mx-auto" />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default Skeleton
